/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputPositionShort } from './OutputPositionShort';
import {
    OutputPositionShortFromJSON,
    OutputPositionShortFromJSONTyped,
    OutputPositionShortToJSON,
} from './OutputPositionShort';
import type { OutputUserShort } from './OutputUserShort';
import {
    OutputUserShortFromJSON,
    OutputUserShortFromJSONTyped,
    OutputUserShortToJSON,
} from './OutputUserShort';
import type { OutputZoneShort } from './OutputZoneShort';
import {
    OutputZoneShortFromJSON,
    OutputZoneShortFromJSONTyped,
    OutputZoneShortToJSON,
} from './OutputZoneShort';

/**
 * 
 * @export
 * @interface OutputMissionShort
 */
export interface OutputMissionShort {
    /**
     * 
     * @type {string}
     * @memberof OutputMissionShort
     */
    finishedAt: string;
    /**
     * 
     * @type {number}
     * @memberof OutputMissionShort
     */
    id: number;
    /**
     * 
     * @type {OutputUserShort}
     * @memberof OutputMissionShort
     */
    pilot: OutputUserShort;
    /**
     * 
     * @type {OutputPositionShort}
     * @memberof OutputMissionShort
     */
    position?: OutputPositionShort;
    /**
     * 
     * @type {string}
     * @memberof OutputMissionShort
     */
    queuedAt: string;
    /**
     * 
     * @type {string}
     * @memberof OutputMissionShort
     */
    status: string;
    /**
     * 
     * @type {OutputZoneShort}
     * @memberof OutputMissionShort
     */
    zone: OutputZoneShort;
}

/**
 * Check if a given object implements the OutputMissionShort interface.
 */
export function instanceOfOutputMissionShort(value: object): boolean {
    if (!('finishedAt' in value)) return false;
    if (!('id' in value)) return false;
    if (!('pilot' in value)) return false;
    if (!('queuedAt' in value)) return false;
    if (!('status' in value)) return false;
    if (!('zone' in value)) return false;
    return true;
}

export function OutputMissionShortFromJSON(json: any): OutputMissionShort {
    return OutputMissionShortFromJSONTyped(json, false);
}

export function OutputMissionShortFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputMissionShort {
    if (json == null) {
        return json;
    }
    return {
        
        'finishedAt': json['finishedAt'],
        'id': json['id'],
        'pilot': OutputUserShortFromJSON(json['pilot']),
        'position': json['position'] == null ? undefined : OutputPositionShortFromJSON(json['position']),
        'queuedAt': json['queuedAt'],
        'status': json['status'],
        'zone': OutputZoneShortFromJSON(json['zone']),
    };
}

export function OutputMissionShortToJSON(value?: OutputMissionShort | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'finishedAt': value['finishedAt'],
        'id': value['id'],
        'pilot': OutputUserShortToJSON(value['pilot']),
        'position': OutputPositionShortToJSON(value['position']),
        'queuedAt': value['queuedAt'],
        'status': value['status'],
        'zone': OutputZoneShortToJSON(value['zone']),
    };
}

